import React, { PureComponent } from 'react';
import { WinnerBadge } from './';
import SimpleAwardBlock from './SimpleAwardBlock';
import styles from './MultiAwardBlock.css';
import ExpandButton from '../ExpandButton';
import BitBackground from '../BitBackground';

class MultiAwardBlock extends PureComponent {
  state = {
    isExpand: true,
  };

  handleExpandClick = () => {
    this.setState(({ isExpand }) => ({
      isExpand: !isExpand,
    }));
  }

  render() {
    const { className, winners, subTitle = '', ...props } = this.props;
    const { isExpand } = this.state;

    if (!winners || !Array.isArray(winners)) {
      return (
        <SimpleAwardBlock
          {...props}
          className={className}
          isLong
        />
      );
    }

    return (
      <div className={`${styles.multi} ${className || ''}`}>
        <SimpleAwardBlock
          {...props}
          className={styles.awardBlock}
          isLong
        >

        </SimpleAwardBlock>
        { subTitle !== "" ? (<div className={styles.subTitle}>{ subTitle }</div>) : ''}

        <div className={`${styles.winnersBlock} ${isExpand ? styles.isExpand : ''}`}>
          {winners.map((winner, i) => (
            <div key={`${winner.name}-${i}`} className={styles.winner}>
              <img src={winner.img} alt={winner.name} />
              <WinnerBadge winner={winner.name} className={styles.winnerBadge} />
            </div>
          ))}

          <BitBackground className={styles.mobileBitBackground} />
        </div>
      </div>
    );
  }
}

export default MultiAwardBlock;



// WEBPACK FOOTER //
// ./src/components/AwardBlock/MultiAwardBlock.js